import React from 'react';
import './ServicePackages.css';
import { Button } from './ButtonElement';

const packages = [
  {
    name: "Essential",
    features: [
      "Remote Monitoring & Management (RMM)",
      "1x Remote-Check inkl. Bericht",
      "30 Minuten Support inkludiert"
    ],
    responseTime: "Reaktionszeit: 48h"
  },
  {
    name: "Business",
    features: [
      "RMM & Updates",
      "2h Support pro Monat",
      "IT-Sicherheitsüberblick",
      "Regelmäßige Systemwartung"
    ],
    responseTime: "Reaktionszeit: 24h"
  },
  {
    name: "Enterprise Care",
    features: [
      "RMM, Updates & Vor-Ort-Service",
      "4h Support pro Monat",
      "Notfallnummer (werktags)",
      "Komplettes IT-Monitoring"
    ],
    responseTime: "Reaktionszeit: < 4h"
  }
];

const modules = [
  {
    name: "Office 365 Wartung",
    description: "Regelmäßige Betreuung und Updates für Ihre Microsoft 365 Umgebung."
  },
  {
    name: "Backup & Restore",
    description: "Zuverlässige Datensicherung und schnelle Wiederherstellung im Notfall."
  },
  {
    name: "Mail Security",
    description: "Schutz Ihrer E-Mails vor Spam, Phishing und Schadsoftware."
  },
  {
    name: "Vor-Ort-Service",
    description: "Persönlicher IT-Support direkt bei Ihnen im Unternehmen."
  },
  {
    name: "Sicherheitspaket – Firewall & Pi-hole",
    description: "Ganzheitliche Netzwerksicherheit inkl. Content-Filterung."
  }
];

const ServicePackages = () => {
  return (
    <div className="service-packages" id="servicepackages">
      <h2>Unsere IT-Servicepakete</h2>
      <div className="package-cards">
        {packages.map((pkg) => (
          <div className="card" key={pkg.name}>
            <h3>{pkg.name}</h3>
            <p className="price">Preis auf Anfrage</p>
            <ul>
              {pkg.features.map((feat, idx) => (
                <li key={idx}>{feat}</li>
              ))}
            </ul>
            <p className="response">{pkg.responseTime}</p>
            <Button
              to="contact"
              smooth={true}
              duration={500}
              spy={true}
              offset={-80}
              primary="true"
              dark="true"
            >
              Angebot anfragen
            </Button>
          </div>
        ))}
      </div>

      <h3 style={{ marginTop: "60px" }}>Zusätzliche Module</h3>
      <div className="package-cards">
        {modules.map((mod, idx) => (
          <div className="card" key={idx}>
            <h3>{mod.name}</h3>
            <p className="price">Preis auf Anfrage</p>
            <p style={{ margin: "15px 0", color: "#333" }}>{mod.description}</p>
            <Button
              to="contact"
              smooth={true}
              duration={500}
              spy={true}
              offset={-80}
              primary="true"
              dark="true"
            >
              Angebot anfragen
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicePackages;
